jQuery( function( $ ) {

	// if navigating away from the checkout page, where the user was directed from the "vuorimiespäivät" booking flow, confirm exit 
	// console.log($('body').hasClass('woocommerce-checkout'), document.referrer.indexOf('vuorimiespaivat') > -1);

	/*
	if (document.referrer.indexOf('vuorimiespaivat') > -1 && $('body').hasClass('woocommerce-checkout')) {
		$(window).on('beforeunload', function() {
			return 'Haluatko varmasti siirtyä pois tältä sivulta? Tällöin ostoskori tyhjennetään, ja menetät varauksesti tiedot.';	
		});	
	}
	*/
});